var p = Object.defineProperty;
var i = (r, e, s) => e in r ? p(r, e, { enumerable: !0, configurable: !0, writable: !0, value: s }) : r[e] = s;
var t = (r, e, s) => (i(r, typeof e != "symbol" ? e + "" : e, s), s);
import { MVTLayer as a } from "@deck.gl/geo-layers/typed";
import { CompositeLayer as n } from "@deck.gl/core/typed";
import { PLVehicleTrafficVolumePathLayer as h } from "./index.es483.js";
class l extends n {
  renderLayers() {
    const e = `${this.props.id}-mvt-vtv`;
    return new a({
      id: e,
      loadOptions: {
        fetch: {
          headers: { Authorization: `Token ${this.props.placerToken}` }
        }
      },
      data: this.props.tileUrl,
      pickable: this.props.pickable,
      visible: this.props.visible,
      /*
       * maxZoom is a very important parameter because static-tiles-service only returns data up to
       * a zoom level of 14, so any higher than that and no data will be returned
       */
      maxZoom: this.props.maxZoom || 14,
      binary: !1,
      opacity: this.props.opacity / 100,
      onHover: this.props.onHover,
      onClick: this.props.onClick,
      refinementStrategy: "no-overlap",
      maxRequests: 3,
      updateTriggers: {
        renderSubLayers: [
          this.props.tileUrl,
          this.props.roadType,
          this.props.userInputRange,
          this.props.hoveredFeatureId,
          this.props.visibleItems
        ]
      },
      renderSubLayers: (o) => [
        new h({
          ...o,
          roadType: this.props.roadType,
          userInputRange: this.props.userInputRange,
          hoveredFeatureId: this.props.hoveredFeatureId,
          visibleItems: this.props.visibleItems
        })
      ]
    });
  }
}
t(l, "layerName", "PLVehicleTrafficVolumeLayer");
export {
  l as PLVehicleTrafficVolumeLayer
};
//# sourceMappingURL=index.es429.js.map
